import { adminAuthApi } from "./api";

// GET: 회원 검사
export const checkAdminApi = (userId) => adminAuthApi.get('/auth/check/' + userId)

// POST: 로그인
export const adminLoginApi = (data) => adminAuthApi.post('/auth/login', data)